import { render } from "./UploadPictures.vue?vue&type=template&id=5e1af9bb&scoped=true"
import script from "./UploadPictures.vue?vue&type=script&lang=js"
export * from "./UploadPictures.vue?vue&type=script&lang=js"

import "./UploadPictures.vue?vue&type=style&index=0&id=5e1af9bb&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1af9bb"]])

export default __exports__